import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { 
  Box, 
  CircularProgress, 
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Tooltip, 
  Typography 
} from '@mui/material';

import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import TableTimeStamps from '../../../../../components/utils/TableTimeStamps';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import { 
  GetPartiesBIZfusionALT 
} from '../../../../../redux/actions/business/fusion/altcard/partiesActions';

const PartiesPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.fusion.altcard"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [partiesList, setPartiesList] = useState([]);
  const [partiesTotal, setPartiesTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Id",
      sort: "id",
    },
    {
      label: "Legal name",
      sort: "legal_name",
    },
    {
      label: "Logo url",
      sort: "logo_url",
    },
    {
      label: "Tax id",
      sort: "tax_id",
    },
    {
      label: "Address",
      sort: "address",
    },
    {
      label: "Contact",
      sort: "contact_name",
    },
    {
      label: "Verification level",
      sort: "verification_level",
    },
    {
      label: "Biz handle",
      sort: "business_handle",
    },
    {
      label: "Is active",
      sort: "is_active",
    },
    {
      label: "Time stamps",
      sort: "createdAt",
    },
    // {
    //   label: "",
    //   sort: null
    // }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetParties();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      console.log(state)
      formatPartiesList(state.partiesList.records || []);
      setPartiesTotal(state.partiesList.total || 0);
    } catch (err) {}
  }, [state]);

  const formatPartiesList = (list) => {
    setPartiesList(list)
  };

  async function handleGetParties(customLoading){
    let query = ""
    if(search) query += `&search=${search}`;
    if(sort) query += `&field=${sort}`;
    if(sortDirection) query += `&order=${sortDirection}`;
    dispatch(GetPartiesBIZfusionALT(page+1, rowsPerPage, query, customLoading ? customLoading : setLoading));
  };

  return (
    <Box>

      <TopBar
        title={"Parties"}
        search={search}
        onSearchChange={(e) => {
          setSearch(e.target.value);
        }}
        />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          partiesList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No party found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                partiesList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        <Copyable>
                          {row.id || <NA />}
                        </Copyable>
                        <Copyable>
                          {row.customer_party_id || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Copyable>
                        {row.legal_name || <NA />}
                      </Copyable>
                      <Tooltip
                        title="Trading name">
                        <Copyable>
                        {row.legal_name || <NA />}
                       </Copyable>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Copyable>
                        {row.logo_url || <NA />}
                      </Copyable>
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Copyable>
                          {row.tax_id || <NA />}
                        </Copyable>
                      </Box>
                      <Box>
                        <Typography
                          variant='caption'>
                          ({row.tax_id_type || <NA />})
                        </Typography>
                      </Box>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        ({row.incorporation_date || <NA />})
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {row.address || <NA />},
                      {row.city || <NA />},
                      {row.state || <NA />},
                      {row.country || <NA />},
                      {row.pincode || <NA />}
                    </TableCell>
                    <TableCell>
                      <Box>
                        {row.email || <NA />}
                      </Box>
                      <Box>
                        <Typography
                          variant='caption'>
                          {row.domain || <NA />}
                        </Typography>
                      </Box>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        {row.contact_name || <NA />}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {row.verification_level || <NA />}
                    </TableCell>
                    <TableCell>
                      <Copyable>
                        {row.business_handle || <NA />}
                      </Copyable>
                    </TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.createdAt}
                        updatedAt={row.updatedAt}
                        />
                    </TableCell>
                    {/* <TableCell>
                      <IconButton
                        onClick={(e) => {
                          setCurrenciesMenuAnchor(e.currentTarget);
                          setCurrenciesMenuOpen(true);
                          setUpdate(row);
                          setModalTitle(row.name || "");
                        }}>
                        <MoreVertIcon sx={{ color: global['secondary_light']}}/>
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={partiesTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default PartiesPage;